import { Button } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { getSnapshotImagesNode } from '../unified-alarm-group/alarm-updates/extraDetailsUtil';

interface Props {
  message: string;
  s3Urls?: string[];
}

export function InlineSMSMessage(props: Props) {
  const { message, s3Urls } = props;
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isExpanded) {
    return (
      <div className="-ml-4 -mt-1">
        <Button
          variant="link"
          className="text-ondark-primary text-xs"
          onClick={() => setIsExpanded(true)}
        >
          View message
        </Button>
      </div>
    );
  }

  return (
    <div className="mt-2 px-3">
      {message && (
        <p className="whitespace-pre-wrap break-words text-xs text-gray-800 dark:text-gray-400">
          {message}
        </p>
      )}
      {s3Urls && s3Urls.length > 0 && (
        <div className="mt-1.5">{getSnapshotImagesNode(undefined, s3Urls)}</div>
      )}
      <Button
        variant="link"
        className="text-ondark-primary -ml-4 -mt-2 text-xs"
        onClick={() => setIsExpanded(false)}
      >
        Hide message
      </Button>
    </div>
  );
}

export default InlineSMSMessage;
